var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"blog-video",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.url[0],"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }